<template>
  <div class="express swiper-container swiper-no-swiping" id="expressnew" v-if="expresslist.length > 0">
    <div class="swiper-wrapper">
      <div class="swiper-slide" v-for="item in expresslist" :key="item.uniquekey">
        <img src="../../../assets/newexpre.png" alt="" width="34px" height="21px">
        <p class="content">{{item.title}}</p>
      </div>
    </div>
  </div>
</template>
<script>
import {request} from '@/api/request'
import Swiper from 'swiper'
import 'swiper/css/swiper.min.css'
import {mapState} from 'vuex'

export default {
  props: {
    stocks: {
      type: String,
      default: '600031',
    }
  },
  data() {
    return {
      expressSwiper: null,
      expresslist: []
    }
  },
  computed: {
    ...mapState(['status', 'code', 'market'])
  },
  watch: {
    code: {
      handler: async function (val, oldVal) {
        await this.loadData()
        this.$nextTick()
          .then(() => {
            this.expressSwiper = new Swiper('#expressnew', {
              // cssMode: true,
              watchOverflow: true,
              loop: this.expresslist.length > 1 ? true : false,
              autoplay: this.expresslist.length > 1 ? {
                delay: 10000,
              } : false,
              direction: 'vertical'
            })
        })
      },
      immediate: true
    }
  },
  methods: {
    async loadData() {
      let res = await request.get({
        url: request.apis.quote.scrollbar,
        params: {
          stocks: this.code
        }
      })
      this.expresslist = res
    }
  }
}
</script>

<style lang="stylus" scoped>
.express
  margin-top .06rem
  height .32rem
  background-color white
  padding 0 64px 0 15px
  .swiper-slide
    display flex
    align-items center
  .content
    text-overflow ellipsis
    overflow hidden
    white-space nowrap
    font-size 13px
    color #666
    padding-left 2px
</style>